import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Paper,
    Typography,
    Grid
} from "@material-ui/core";
import API from "../../actions";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SimpleInput from "../Frequents/SimpleInput";
import TextEditor from "../Frequents/TextEditor.js";
import Clock from "../Frequents/TimePicker.js";
import DatePicker from "../Frequents/DatePicker.js";
import moment from "moment";
import update from "immutability-helper";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    actionsContainer: {
        marginBottom: theme.spacing(2)
    },
    resetContainer: {
        padding: theme.spacing(3)
    }
}));

export default props => {
    // Kursus parametre
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [date, setDate] = useState([]);
    const [min, setMin] = useState(0);
    const [limit, setLimit] = useState(0);
    const [course, setCourse] = useState({});

    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Navn og beskrivelse", "Kursusdage", "Deltagere"];

    const handleClose = () => {
        setOpen(false);
        setActiveStep(0);
    };

    const handleDelete = async () => {
        if (!window.confirm("Er du sikker?")) return;
        handleClose();
        await API.deleteEvent(course.id);
        props.getCourses();
    };

    const handleNew = async () => {
        if(parseInt(limit) < parseInt(min)){
            alert("Minimum antal deltagere kan ikke være højere end max antal deltagere");
        }else{
            const newEventId = await API.addEvent(title, description, limit,parseInt(min));
            await Promise.all(
                date.map(async d => {
                    d.eventId = newEventId;
                    d.from = Date.parse(d.day + "T" + d.start);
                    d.to = Date.parse(d.day + "T" + d.end);
                    await API.addEventDates(newEventId, [{ from: d.from, to: d.to, latestDays: parseInt(d.latestDays)}]);
                })
            );
            setOpen(false);
            props.getCourses();
        }
    };

    const handleEdit = () => {
        if(parseInt(limit) < parseInt(min)){
            alert("Minimum antal deltagere kan ikke være højere end max antal deltagere");
        }else{
            API.setEvent(
                update(course, { title: { $set: title }, description: { $set: description }, limit: { $set: limit }, min: { $set:parseInt(min) } })
            );
            date.forEach(async d => {
                const dNew = update(d, {
                    eventId: { $set: course.id },
                    from: { $set: Date.parse(d.day + "T" + d.start) },
                    to: { $set: Date.parse(d.day + "T" + d.end) },
                    latestDays: { $set: d.latestDays }
                });
                d.id
                    ? await API.setEventDate(dNew)
                    : await API.addEventDates(dNew.eventId, [{ from: dNew.from, to: dNew.to,latestDays: dNew.latestDays}]);
            });
            setOpen(false);
        }
    };

    const handleDeleteDate = (id, i) => {
        if (!window.confirm("Er du sikker?")) return;
        API.deleteEventDate(id);
        setDate(update(date, { $splice: [[i, 1]] }));
    };

    useEffect(() => {
        console.log("props.course",props.course);
        if (props.course) {
            setCourse(props.course);
            setTitle(props.course.title);
            setDescription(props.course.description);
            setMin(props.course.min);
            setLimit(props.course.limit);
            setDate(
                props.course.dates.map(d => {
                    const eDay = moment(new Date(Number(d.from))).format("YYYY-MM-DD");
                    const eStart = moment(new Date(Number(d.from))).format("HH:mm:ss");
                    const eEnd = moment(new Date(Number(d.to))).format("HH:mm:ss");
                    const eId = d.id;
                    const eLatestDays = Number(d.latestDays);
                    return { day: eDay, start: eStart, end: eEnd, id: eId ,latestDays:eLatestDays};
                })
            );
        }
    }, [props.course]);

    const getStepContent = step => {
        switch (step) {
            case 0:
                return (
                    <>
                        <SimpleInput
                            name="courseName"
                            text="Kursusnavn"
                            key="courseName"
                            type="text"
                            prop={title}
                            changeValue={setTitle}
                        />
                        <TextEditor value={description} onChange={setDescription} />
                    </>
                );
            case 1:
                return (
                    <>
                        {date.map((felter, index) => {
                            return (
                                <Grid
                                    container
                                    spacing={0}
                                    style={{
                                        backgroundColor: "rgba(220,220,220,0.5)",
                                        padding: "5px 10px 10px 10px",
                                        borderRadius: "5px"
                                    }}>
                                    <Grid item sm={3} style={{ width: "100%", paddingTop: "7.5px" }}>
                                        <DatePicker
                                            date={felter.day}
                                            onChangeValue={value =>
                                                setDate(
                                                    update(date, {
                                                        [index]: {
                                                            day: { $set: moment(value._d).format("YYYY-MM-DD") }
                                                        }
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item sm={2} style={{ width: "100%", paddingTop: "13.5px" }}>
                                        <SimpleInput
                                            name="latestDays"
                                            text="Deadline antal dage før kursus"
                                            key="latestDays"
                                            type="number"
                                            prop={felter.latestDays}
                                            changeValue={value=>{
                                                setDate(
                                                    update(date, {
                                                        [index]: {
                                                            latestDays: { $set: value }
                                                        }
                                                    })
                                                );
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={2} style={{ width: "100%" }}>
                                        <Clock
                                            style={{ flex: 1 }}
                                            value={felter.start}
                                            changeValue={value => {
                                                if (felter.end && value > felter.end)
                                                    alert("Starttidspunkt skal være før sluttidspunkt!");
                                                else
                                                    setDate(
                                                        update(date, {
                                                            [index]: {
                                                                start: { $set: value }
                                                            }
                                                        })
                                                    );
                                            }}
                                            text="Start"
                                        />
                                    </Grid>
                                    <Grid item sm={2} style={{ width: "100%" }}>
                                        <Clock
                                            style={{ flex: 1 }}
                                            value={felter.end}
                                            changeValue={value => {
                                                if (felter.start && value < felter.start)
                                                    alert("Sluttidspunkt skal være efter starttidspunkt!");
                                                else
                                                    setDate(
                                                        update(date, {
                                                            [index]: {
                                                                end: { $set: value }
                                                            }
                                                        })
                                                    );
                                            }}
                                            text="Slut"
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        sm={2}
                                        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Button onClick={() => handleDeleteDate(felter.id, index)} color="secondary">
                                            Slet
                                        </Button>
                                    </Grid>
                                </Grid>
                            );
                        })}

                        <Button
                            onClick={() =>{
                                    let firstDate = date[0];
                                    let defaultLatestDays = 0;
                                    if(firstDate){
                                        defaultLatestDays = firstDate.latestDays;
                                    }
                                    setDate(
                                        update(date, {
                                            $push: [{ day: moment().format("YYYY-MM-DD"), start: "", end: "" ,latestDays:defaultLatestDays}]
                                        })
                                    )
                                }
                            }
                            style={{ margin: "30px 0 20px 0", backgroundColor: "#343434", color: "#fff" }}
                            variant="contained"
                            startIcon={<AddCircleIcon />}>
                            Ny kursusdag
                        </Button>
                    </>
                );
            case 2:
                return (
                    <>
                    <SimpleInput
                        name="minparcipantNumer"
                        text="Min antal deltagere"
                        key="minparcipantNumer"
                        type="number"
                        prop={min}
                        changeValue={value=>{
                            setMin(value);
                        }}
                    />
                    <SimpleInput
                        name="parcipantNumer"
                        text="Max antal deltagere"
                        key="parcipantNumer"
                        type="number"
                        prop={limit}
                        changeValue={value=>{
                            setLimit(value);
                        }}
                    />
                    </>
                );
            default:
                return "Unknown step";
        }
    };

    return (
        <div>
            {props.new ? (
                <Button
                    onClick={() => setOpen(true)}
                    style={{ margin: "30px 0 20px 0", backgroundColor: "#343434", color: "#fff", float: "right" }}
                    variant="contained"
                    startIcon={<AddCircleIcon />}>
                    Nyt Kursus
                </Button>
            ) : (
                <Button onClick={() => setOpen(true)} size="small">
                    Rediger
                </Button>
            )}

            <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth={true}>
                {props.new ? (
                    <DialogTitle id="form-dialog-title">Lav nyt kursus</DialogTitle>
                ) : (
                    <DialogTitle id="form-dialog-title">Rediger kursus</DialogTitle>
                )}
                <DialogContent>
                    <div className={classes.root}>
                        <Stepper activeStep={activeStep} orientation="vertical">
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                    <StepContent>
                                        <Typography>{getStepContent(index)}</Typography>
                                        <div className={classes.actionsContainer}>
                                            <div>
                                                <Button
                                                    disabled={activeStep === 0}
                                                    onClick={() => setActiveStep(prevActiveStep => prevActiveStep - 1)}
                                                    className={classes.button}>
                                                    Tilbage
                                                </Button>
                                                <Button
                                                    disabled={activeStep === steps.length - 1 && !props.new}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={async () => {
                                                        if (activeStep !== steps.length - 1) {
                                                            setActiveStep(prevActiveStep => prevActiveStep + 1);
                                                            return;
                                                        }
                                                        if (props.new) handleNew();
                                                        else {
                                                            await handleEdit();
                                                            await props.getCourses();
                                                        }
                                                    }}
                                                    className={classes.button}>
                                                    {activeStep === steps.length - 1 ? (
                                                        <>{props.new ? "Opret" : "Næste"}</>
                                                    ) : (
                                                        "Næste"
                                                    )}
                                                </Button>
                                            </div>
                                        </div>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                        {activeStep === steps.length && (
                            <Paper square elevation={0} className={classes.resetContainer}>
                                <Typography>All steps completed - you&apos;re finished</Typography>
                                <Button onClick={() => setActiveStep(0)} className={classes.button}>
                                    Reset
                                </Button>
                            </Paper>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    {props.new ? (
                        ""
                    ) : (
                        <>
                            <Button onClick={handleDelete} color="secondary">
                                Slet
                            </Button>
                            <Button
                                onClick={async () => {
                                    await handleEdit();
                                    await props.getCourses();
                                }}
                                color="primary">
                                Gem
                            </Button>
                        </>
                    )}
                    <Button onClick={handleClose} color="primary">
                        Luk
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
